export const STATE_UPDATE = '@gstin/State Update';
export const USER_CONSENT = '@gstin/Consent Issued';
export const HIGHLIGHT_USER_CONSENT_ERROR = '@gstin/Highlight User Consent Error';
export const INITIALISE_GSTIN = '@gstin/Initialise';

const initialise = (response: string) => {
    return {
        type: INITIALISE_GSTIN,
        payload: response,
    };
};

const state = (response: string) => {
    return {
        type: STATE_UPDATE,
        payload: response,
    };
};

const userConsent = (response: boolean) => {
    return {
        type: USER_CONSENT,
        payload: response,
    };
};

export const highlightUserConsentError = (response: boolean) => {
    return {
        type: HIGHLIGHT_USER_CONSENT_ERROR,
        payload: response,
    };
};

export const initialiseGSTIN = (data: string) => {
    return async (dispatch: any) => {
        dispatch(initialise(data));
    };
};

export const stateUpdate = (data: string) => {
    return async (dispatch: any) => {
        dispatch(state(data));
    };
};

export const userConsentUpdate = (data: boolean) => {
    return async (dispatch: any) => {
        dispatch(userConsent(data));
    };
};

export const highlightUserConsentErrorUpdate = (data: boolean) => {
    return async (dispatch: any) => {
        dispatch(highlightUserConsentError(data));
    };
};
